import { Service } from '@tino-frontend/adapters'
import type { SinglePlayerBoletosResponse, CreateBoletoRequest } from '@types'

export class SinglePlayerService {
  constructor(
    private readonly singlePlayer: Service,
    private readonly merchantBff: Service
  ) {}

  async getByMerchantId(
    merchantId: string
  ): Promise<SinglePlayerBoletosResponse> {
    return this.singlePlayer
      .get<
        unknown,
        { data: SinglePlayerBoletosResponse }
      >(`/v1/boletos/${merchantId}`)
      .then((response) => response.data)
  }

  async createBoleto(request: CreateBoletoRequest): Promise<void> {
    return this.singlePlayer.post(`/v1/boletos`, request)
  }

  async estimateDueDates(
    companyId: string,
    dueDates: string[]
  ): Promise<string[]> {
    return this.merchantBff.post('/v1/estimate_due_dates', {
      company_id: companyId,
      dates: dueDates,
    })
  }
}
